module.exports = __webpack_public_path__ + "static/media/portfolio-6.a274b373.png";